var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.83594,
    width: 37,
    height: 37,
    rx: 7,
    fill: "#0055FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.83594,
    width: 43,
    height: 43,
    rx: 9,
    stroke: "#0055FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.369 31.1637C13.7912 31.1637 13.2947 30.9561 12.8794 30.5408C12.4641 30.1255 12.2565 29.629 12.2565 29.0512V15.9429C12.2565 15.3651 12.4641 14.8686 12.8794 14.4533C13.2947 14.038 13.7912 13.8304 14.369 13.8304H31.8107C32.3885 13.8304 32.885 14.038 33.3003 14.4533C33.7155 14.8686 33.9232 15.3651 33.9232 15.9429V29.0512C33.9232 29.629 33.7155 30.1255 33.3003 30.5408C32.885 30.9561 32.3885 31.1637 31.8107 31.1637H14.369ZM14.369 29.0512H22.0336V15.9429H14.369V29.0512ZM24.1461 29.0512H31.8107V15.9429H24.1461V29.0512ZM15.4794 26.8304H20.9232V24.7179H15.4794V26.8304ZM15.4794 23.5804H20.9232V21.4408H15.4794V23.5804ZM15.4794 20.3033H20.9232V18.1637H15.4794V20.3033ZM25.2565 26.8304H30.7003V24.7179H25.2565V26.8304ZM25.2565 23.5804H30.7003V21.4408H25.2565V23.5804ZM25.2565 20.3033H30.7003V18.1637H25.2565V20.3033ZM22.0336 29.0512V15.9429V29.0512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.150afe788df31226d32e512500d87b60.svg";
export { ForwardRef as ReactComponent };